// extracted by mini-css-extract-plugin
module.exports =  {"link":"HApVuO","defaultWeight":"oG3uGK"};